exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-table__body-wrapper::-webkit-scrollbar{width:6px;height:6px}.el-table__body-wrapper::-webkit-scrollbar-thumb{background-color:#ddd;border-radius:3px}\n", ""]);

// exports
